import React from 'react';
import { Dialog, Box } from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import styles from './styles.module.scss';
import './styles.global.scss';
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";


const ProgressModal = ({ open, setOpen, filesNumber, progress, title, stage, closable = true, indeterminate = false }) => {
  const dimensions = useSelector(state => state.dimensions);

  return (
    <>
      <Dialog open={open} className={'ProgressDialog'} onClose={() => {}} fullScreen={dimensions.isScreenLessSM}>
        <MuiDialogTitle>
          <Box className={`${styles.modalTitle} ${dimensions.isScreenLessMD ? styles.mobile : ''}`}>
            {title ?? `Uploading ${filesNumber ?? ''} file${filesNumber === 1 ? '' : 's'}`}
          </Box>
          {closable && (
            <IconButton aria-label="close" className={styles.closeButton} onClick={() => setOpen(false)} data-testid="button-progress-modal-close">
              <CloseRoundedIcon />
            </IconButton>
          )}
        </MuiDialogTitle>
        <MuiDialogContent>
          <div className={`${styles.progressBarContainer} ${!indeterminate && !progress && progress !== 0 ? styles.transparent : ''}`} data-testid="progress-modal-bar">
            <div className={`${styles.progressBar} ${indeterminate ? styles.indeterminate : ''}`} style={indeterminate ? undefined : { width: `${progress}%` }} />
          </div>
          {!indeterminate && <span className={styles.percentageText} data-testid="progress-modal-percent">{progress ?? 0}%</span>}
          {!!stage && <Box sx={{ mt: 2 }} className={styles.stageText}>{stage}</Box>}
        </MuiDialogContent>
      </Dialog>
    </>
  );
};

ProgressModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  filesNumber: PropTypes.number,
  progress: PropTypes.number,
  title: PropTypes.string,
  stage: PropTypes.string,
  closable: PropTypes.bool,
  indeterminate: PropTypes.bool,
};

export default ProgressModal;
